import type { PayloadAction } from '@reduxjs/toolkit';

import type { ProcessFlowState } from './_state.type';

/** ProcessFlow Reducer. */
export const processFlowReducer = {
  // #region - ProcessFlow

  /**
   * ProcessFlow setData.
   *
   * @param {ProcessFlowState} state State.
   * @param {PayloadAction<string | undefined>} action Action.
   */
  processFlow_setData: (state: ProcessFlowState, { payload }: PayloadAction<string | undefined>) => {
    state.processFlow.dataJSON = payload;
  },

  /**
   * ProcessFlow setRawInitialSteps.
   *
   * @param {ProcessFlowState} state State.
   * @param {PayloadAction<string | undefined>} action Action.
   */
  processFlow_setRawInitialSteps: (state: ProcessFlowState, { payload }: PayloadAction<string | undefined>) => {
    state.processFlow.rawInitialStepsJSON = payload;
  },

  // #endregion

  // #region - Barcode Zone

  /**
   * ProcessFlow setBarcodeZone.
   *
   * @param {ProcessFlowState} state State.
   * @param {PayloadAction<ProcessFlowState['barCodeZone']>} action Action.
   */
  processFlow_setBarcodeZone(state: ProcessFlowState, { payload }: PayloadAction<ProcessFlowState['barCodeZone']>) {
    state.barCodeZone = payload;
  },

  // #endregion
};
